import React from 'react';
import { connect } from 'react-redux';
import { actions, apiActions } from '../../../actions';
import Form from './Form'

class UpdateForm extends React.Component {

  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    event.keyCode == 27
    ? this.props.closeForm()
    : this.props.setFormBody(event.target.value)
  }

  submit(event) {
    event.preventDefault();
    const { form, successMsg, commentBlank, popCommentOrReplyUpdate } = this.props;
    form.body !== ''
      ? popCommentOrReplyUpdate(form, successMsg)
      : setNoticeError(commentBlank)
  }

  render = () => (
    <Form {...this.props} submit={this.submit} handleInputChange={this.handleInputChange} />
  )
}

const mapState = (state, ownProps ) => ({
  form: state.update_form,
  commentBlank: I18n.t('components.webreader_comments_list').commentBlank,
  successMsg: I18n.t('components.webreader_comments_list.comment_edited')
});

const mapDispatch = (dispatch, ownProps) => ({
  popCommentOrReplyUpdate: (form, successMsg) => {
    dispatch(apiActions.popCommentOrReplyUpdate(form, successMsg))
  },
  closeForm: () => {
    dispatch(actions.closeUpdateForm())
    dispatch(actions.hideSmallSpinner())
  },
  setFormBody: (body) => {
    dispatch(actions.setUpdateFormBody(body))
  },
});

export default connect(mapState, mapDispatch)(UpdateForm);
